// Shared TanStack Query client. A single configured instance for the whole app
// so cache behaviour is consistent and tunable in one place.
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Near-real-time collaboration. Data Connect has no push subscriptions,
      // so the register, working papers, findings, allocations, dashboard and
      // user list stay live by polling: another reviewer's or admin's work
      // shows up within ~20s without a reload.
      staleTime: 10_000,
      // Poll every 20s, but only while the tab is focused — hidden tabs don't
      // poll, which keeps Cloud SQL load proportional to who's actually working.
      refetchInterval: 20_000,
      refetchIntervalInBackground: false,
      // Returning to the tab or recovering the network refreshes immediately.
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      // One retry smooths over transient network blips without long stalls.
      retry: 1,
    },
  },
});
